<template>

  <div class="needs_part">

    <div class="needs_start">
      <h1>最懂你的人生藍圖計算機</h1>
      <p class="start_text">
        聽別人的故事，寫自己的人生。<br>
        請點選下列各人物情境，一起看看這些人生計劃，<br>
        若在你身上，又該如何達成呢？
      </p>
      <div class="needs_select">
        <div class="select_arrow">
          <select v-model="selected">
            <option value="">請選擇</option>
            <option v-for="option in options" :value="option.id" :key="option.id" :disabled="option.disabled">
              {{ option.text }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-xs-12 col-sm-6 col-sm-offset-3 col-md-6 col-md-offset-3 form-group">
        <div class="share_btn share_btn_blueDefault">
          <a @click="goScenario(selected)">實現人生藍圖 Go</a>
        </div>
      </div>
    </div>

    <div class="needs_people">
      <div class="people_size">
        <div class="people_wrap pc">
          <div class="fourth people_posision" @click="changeValue(selected)">
            <div class="people_diolog" v-if="selected === 'fourth'">
              <div class="diolog_inner">
                <h4>四姐的創業理想</h4>
                <div class="diolog_img">
                  <img src="../assets/images/needs/start_d.svg" alt="">
                </div>
                <p>實現理想的路上，若有足夠的創業基金，似乎離夢想又更近了點！</p>
              </div>
            </div>
            <div class="people_img">
              <picture>
                <source media="(max-width: 767px)" srcset="../assets/images/needs/house_m.svg"/>
                <img src="../assets/images/needs/house.svg" alt="">
              </picture>
            </div>

          </div>
          <div class="firstone people_posision">
            <div class="people_diolog" v-if="selected === 'educationFund'">
              <div class="diolog_inner">
                <h4>大哥的小寶貝剛出生</h4>
                <div class="diolog_img">
                  <img src="../assets/images/needs/child_d.svg" alt="">
                </div>
                <p>孩子的未來不能等！老婆～我們趕快開始存錢，我想把最好的都給孩子。
                </p>
              </div>
            </div>
            <div class="people_img">
              <picture>
                <source media="(max-width: 767px)" srcset="../assets/images/needs/child_m.svg"/>
                <img src="../assets/images/needs/child.svg" alt="">
              </picture>
            </div>
          </div>
          <div class="second people_posision">
            <div class="people_diolog" v-if="selected === 'buyHouse'">
              <div class="diolog_inner">
                <h4>二哥的買房妙計</h4>
                <div class="diolog_img">
                  <img src="../assets/images/needs/house_d.svg" alt="">
                </div>
                <p>不想再當無殼蝸牛了！希望可以早點買到一間自己的房子。</p>
              </div>
            </div>
            <div class="people_img">
              <picture>
                <source media="(max-width: 767px)" srcset="../assets/images/needs/start_m.svg"/>
                <img src="../assets/images/needs/start.svg" alt="">
              </picture>
            </div>
          </div>
          <div class="third people_posision">
            <div class="people_diolog" v-if="selected === 'gold'">
              <div class="diolog_inner">
                <h4>三姐的單身小美好</h4>
                <div class="diolog_img">
                  <img src="../assets/images/needs/gold_d.svg" alt="">
                </div>
                <p>無拘無束超棒！結婚未知、生小孩未知，我就是想過上高品質的生活。</p>
              </div>
            </div>
            <div class="people_img">
              <picture>
                <source media="(max-width: 767px)" srcset="../assets/images/needs/marry_m.svg"/>
                <img src="../assets/images/needs/marry.svg" alt="">
              </picture>
            </div>
          </div>
          <div class="retire people_posision">
            <div class="people_diolog" v-if="selected === 'retire'">
              <div class="diolog_inner">
                <h4>老爸的退休計畫</h4>
                <div class="diolog_img">
                  <img src="../assets/images/needs/retire_d.svg" alt="">
                </div>
                <p>現在就開始替退休做準備，屆時就可以遊山玩水，過上愜意的生活吧？</p>
              </div>
            </div>
            <div class="people_img">
              <picture>
                <source media="(min-width: 1025px)" srcset="../assets/images/needs/retire.svg"/>
                <source media="(max-width: 1024px) and (min-width: 768px)"
                        srcset="../assets/images/needs/retire_pad.svg"/>
                <source media="(max-width: 767px)" srcset="../assets/images/needs/retire_m.svg"/>
                <img src="../assets/images/needs/retire.svg" alt="">
              </picture>
            </div>
          </div>
          <div class="gold people_posision">
            <div class="people_diolog" v-if="selected === 'marry'">
              <div class="diolog_inner">
                <h4>小妹的結婚藍圖</h4>
                <div class="diolog_img">
                  <img src="../assets/images/needs/marry_d.svg" alt="">
                </div>
                <p>
                  好想趕快和他步入婚姻！兩人一起，結婚基金應該也沒那麼難存吧？
                </p>
              </div>
            </div>
            <div class="people_img">
              <picture>
                <img src="../assets/images/needs/gold.svg" alt="">
              </picture>
            </div>
          </div>
        </div>
        <div class="people_wrap mobile">
          <!-- <div class="house people_posision" v-if="selected === '0'">
            <div class="people_img">
              <picture>
                <img src="../images/needs/cover_m.svg" alt="">
              </picture>
            </div>

          </div> -->
          <div class="fourth people_posision" v-if="selected === 'fourth'">
            <div class="people_diolog">
              <div class="diolog_inner">
                <h4>四姐的創業理想</h4>
                <div class="diolog_img">
                  <img src="../assets/images/needs/start_d.svg" alt="">
                </div>
                <p>實現理想的路上，若有足夠的創業基金，似乎離夢想又更近了點！</p>
              </div>
            </div>
            <div class="people_img">
              <picture>
                <img src="../assets/images/needs/house_m.svg" alt="">
              </picture>
            </div>

          </div>
          <div class="firstone people_posision" v-if="selected === 'educationFund'">
            <div class="people_diolog">
              <div class="diolog_inner">
                <h4>大哥的小寶貝剛出生</h4>
                <div class="diolog_img">
                  <img src="../assets/images/needs/child_d.svg" alt="">
                </div>
                <p>孩子的未來不能等！老婆～我們趕快開始存錢，我想把最好的都給孩子。
                </p>
              </div>
            </div>
            <div class="people_img">
              <picture>
                <img src="../assets/images/needs/child_m.svg" alt="">
              </picture>
            </div>
          </div>
          <div class="second people_posision" v-if="selected === 'buyHouse'">
            <div class="people_diolog">
              <div class="diolog_inner">
                <h4>二哥的買房妙計</h4>
                <div class="diolog_img">
                  <img src="../assets/images/needs/house_d.svg" alt="">
                </div>
                <p>不想再當無殼蝸牛了！希望可以早點買到一間自己的房子。</p>
              </div>
            </div>
            <div class="people_img">
              <picture>
                <img src="../assets/images/needs/start_m.svg" alt="">
              </picture>
            </div>
          </div>
          <div class="third people_posision" v-if="selected === 'gold'">
            <div class="people_diolog">
              <div class="diolog_inner">
                <h4>三姐的單身小美好</h4>
                <div class="diolog_img">
                  <img src="../assets/images/needs/gold_d.svg" alt="">
                </div>
                <p>無拘無束超棒！結婚未知、生小孩未知，我就是想過上高品質的生活。</p>
              </div>
            </div>
            <div class="people_img">
              <picture>
                <img src="../assets/images/needs/marry_m.svg" alt="">
              </picture>
            </div>
          </div>
          <div class="retire people_posision" v-if="selected === 'retire'">
            <div class="people_diolog">
              <div class="diolog_inner">
                <h4>老爸的退休計畫</h4>
                <div class="diolog_img">
                  <img src="../assets/images/needs/retire_d.svg" alt="">
                </div>
                <p>現在就開始替退休做準備，屆時就可以遊山玩水，過上愜意的生活吧？</p>
              </div>
            </div>
            <div class="people_img">
              <picture>
                <img src="../assets/images/needs/retire_m.svg" alt="">
              </picture>
            </div>
          </div>
          <div class="gold people_posision" v-if="selected === 'marry'">
            <div class="people_diolog">
              <div class="diolog_inner">
                <h4>小妹的結婚藍圖</h4>
                <div class="diolog_img">
                  <img src="../assets/images/needs/marry_d.svg" alt="">
                </div>
                <p>
                  好想趕快和他步入婚姻！兩人一起，結婚基金應該也沒那麼難存吧？
                </p>
              </div>
            </div>
            <div class="people_img">
              <picture>
                <img src="../assets/images/needs/gold_m.svg" alt="">
              </picture>
            </div>
          </div>
        </div>

      </div>


    </div>


  </div>

</template>

<script>


export default {
  name: "index",
  data: function () {
    return {
      selected: '',
      options: [
          {
        id: 'retire',
        text: '退休',
        disabled: false,
      },
        {
          id: 'buyHouse',
          text: '買房',
          disabled: false,
        },
        {
          id: 'educationFund',
          text: '養育子女',
          disabled: false,
        },
        {
          id: 'gold',
          text: '單身貴族（火速開發中）',
          disabled: true,
        },
        {
          id: 'fourth',
          text: '創業（火速開發中）',
          disabled: true,
        },
        {
          id: 'marry',
          text: '結婚（火速開發中）',
          disabled: true,
        },
      ]
    }
  },
  methods: {
    goScenario(moduleName) {
      if (!moduleName) return;

      // 儲存模組名稱到 store (如果需要的話)
      store.commit('moduleName', moduleName)

      // 根據選擇的模組直接跳轉到對應頁面
      if (moduleName === 'retire') {
        window.location.href = '/needs_analysis/retire';
      } else if (moduleName === 'buyHouse') {
        window.location.href = '/needs_analysis/real_estate';
      } else if (moduleName === 'educationFund') {
        window.location.href = '/needs_analysis/education_fund';
      }
    }
  },
  computed: {},
}

</script>

<style scoped>
</style>